import React from "react";
import "../../pages/About/AboutPage.css";
import { Link } from "react-router-dom";
import cv from "../../cv/cv.pdf";
import { ButtomGet } from "../ButtomGet/ButtomGet";

/* Multi idioma */
import { FormattedMessage } from "react-intl";

const About = () => (
  <section className="sobre-mi" id="sobre-mi">
    <h2 className="heading">
      <FormattedMessage id="about" defaultMessage="About me" />
    </h2>

    <div className="row container">
      <div className="columns" data-aos="fade-right" data-aos-delay="300">
        <h3>
          <FormattedMessage id="im" defaultMessage="who I am" />
        </h3>
        <h4>
          <FormattedMessage
            id="description"
            defaultMessage="I'm Dennis and I am a web3 full stack developer."
          />
        </h4>
        <p>
          <FormattedMessage
            id="my-description"
            defaultMessage="I am an experienced engineer with over 7 years of experience handling all aspects
                        of the development process for high-scale web and mobile applications. My
                        proficiency in diverse industries such as AI, Blockchain, E-commerce, Healthcare,
                        and Education has allowed me to understand my clients business needs
                        successfully. I have built and managed secure websites and possess
                        comprehensive knowledge of web security."
          />
        </p>
        <ul>
          <li>
            <p>
              <span>
                <FormattedMessage id="years" defaultMessage="Age: " />
              </span>
              28
            </p>
          </li>
          <li>
            <p>
              <span>Hobbies: </span>
              Chess, Football and Programming
            </p>
          </li>
          <li>
            <p>
              <span>Email:</span> dennis.dj428@gmail.com
            </p>
          </li>
          <li>
            <p>
              <span>
                <FormattedMessage id="from" defaultMessage="From: " />
              </span>
              Wroclaw, Poland
            </p>
          </li>
        </ul>
        {/* <div className="mas-info">
          <a
            href={cv}
            target="_blank"
            rel="noopener noreferrer"
            download="cv.pdf"
            className="btn-codigo buttonDownload"
          >
            <FormattedMessage id="btn-cv" defaultMessage="Download CV" />
          </a>
          <div className="mas-info-btn">
            <Link to="/about">
              <ButtomGet />
            </Link>
          </div>
        </div> */}
      </div>
      <div
        className="columns col-skill"
        data-aos="fade-left"
        data-aos-delay="650"
      >
        <h3>skills</h3>
        <h4>BlockChain</h4>
        <div className="skill">
          <div>
            <img
              alt="SOLANA"
              className="icons-skils"
              src="https://cryptologos.cc/logos/solana-sol-logo.png?v=032"
            />
            <h5>SOLANA</h5>
          </div>
          <div>
            <img
              alt="ETHEREUME"
              className="icons-skils"
              src="https://cdn.worldvectorlogo.com/logos/ethereum-cash.svg"
            />
            <h5>ETHEREUME</h5>
          </div>
          <div>
            <img
              alt="BITCOIN"
              className="icons-skils"
              src="https://www.svgrepo.com/show/277188/bitcoin.svg"
            />
            <h5>BITCOIN</h5>
          </div>
          <div>
            <img
              alt="CARDANO"
              className="icons-skils"
              src="https://cdn.worldvectorlogo.com/logos/cardano.svg"
            />
            <h5>CARDANO</h5>
          </div>
        </div>
        <h4>Front-End</h4>
        <div className="skill">
          <div>
            <img
              alt="HTML"
              className="icons-skils"
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg"
            />
            <h5>HTML</h5>
          </div>
          <div>
            <img
              alt="CSS"
              className="icons-skils"
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg"
            />
            <h5>CSS</h5>
          </div>
          <div>
            <img
              alt="Js"
              className="icons-skils"
              src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-plain.svg"
            />
            <h5>JavaScript</h5>
          </div>
          <div>
            <img
              alt="Sass"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg"
            />
            <h5>Sass</h5>
          </div>
          <div>
            <img
              alt="Bootstrap"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg"
            />
            <h5>Bootstrap</h5>
          </div>
          <div>
            <img
              alt="Tailwindcss"
              className="icons-skils"
              src="https://www.svgrepo.com/show/374118/tailwind.svg"
            />
            <h5>Tailwindcss</h5>
          </div>
          <div>
            <img
              alt="Styled-Components"
              className="icons-skils"
              src="https://nodeployfriday.com/images/ndf-logo.svg"
            />
            <h5>Styled-Components</h5>
          </div>
          <div>
            <img
              alt="jQuery"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jquery/jquery-plain-wordmark.svg"
            />
            <h5>jQuery</h5>
          </div>
          <div>
            <img
              alt="React"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
            />
            <h5>React</h5>
          </div>
          <div>
            <img
              alt="Typescript"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg"
            />
            <h5>Typescript</h5>
          </div>
        </div>
        <h4>Back-End</h4>
        <div className="skill">
          <div>
            <img
              alt="Nodejs"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg"
            />
            <h5>NodeJs</h5>
          </div>
          <div>
            <img
              alt="express"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg"
            />
            <h5>Express</h5>
          </div>
          <div>
            <img
              alt="mongodb"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain-wordmark.svg"
            />
            <h5>MongodDB</h5>
          </div>
          <div>
            <img
              alt="php"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg"
            />
            <h5>PHP</h5>
          </div>
          <div>
            <img
              alt="RUST"
              className="icons-skils"
              src="https://cdn.iconscout.com/icon/free/png-256/free-resolving-3521761-2945205.png"
            />
            <h5>RUST</h5>
          </div>
          <div>
            <img
              alt="GOLANG"
              className="icons-skils"
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTAnGZfcJP5N6TpSUQ05JgzM7XCWgAiWaWWX7hWfJI0xZpcwtWolaN4PR9N1gN1T_XN8jg&usqp=CAU"
            />
            <h5>GOLANG</h5>
          </div>
          <div>
            <img
              alt="SOLIDITY"
              className="icons-skils"
              src="data:image/png;base64,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"
            />
            <h5>SOLIDITY</h5>
          </div>
        </div>
        <h4>
          <FormattedMessage id="tools" defaultMessage="Tools" />
        </h4>
        <div className="skill">
          <div>
            <img
              alt="figma"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg"
              title="figma"
            />
            <h5>Figma</h5>
          </div>
          <div>
            <img
              alt="photoshop"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/photoshop/photoshop-plain.svg"
              title="Photoshop"
            />
            <h5>Photoshop</h5>
          </div>
          <div>
            <img
              alt="Visual Studio Code"
              className="icons-skils"
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Visual_Studio_Code_1.18_icon.svg/1200px-Visual_Studio_Code_1.18_icon.svg.png"
              title="Visual Studio Code"
            />
            <h5>VS Code</h5>
          </div>
          <div>
            <img
              alt="git"
              className="icons-skils"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg"
              title="git"
            />
            <h5>Git</h5>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default React.memo(About);
